const form = document.querySelector('section.form');

if(form) {
  const langSelect = form.querySelector('.lang-select');
  if(langSelect) {
    const btn_nb = langSelect.querySelector('button.btn-nb') ;
    const btn_nn = langSelect.querySelector('button.btn-nn') ;
    btn_nb.addEventListener('click', function(e) {
      if(!btn_nb.classList.contains('active')) {
        btn_nb.classList.add('active');
        form.querySelector('.form-nb').classList.add('show');
        if(btn_nn.classList.contains('active')) {
          btn_nn.classList.remove('active');
          form.querySelector('.form-nn').classList.remove('show');
        }
      }
    });
    btn_nn.addEventListener('click', function(e) {
      if(!btn_nn.classList.contains('active')) {
        btn_nn.classList.add('active');
        form.querySelector('.form-nn').classList.add('show');
        if(btn_nb.classList.contains('active')) {
          btn_nb.classList.remove('active');
          form.querySelector('.form-nb').classList.remove('show');
        }
      }
    });
  }
}